import React, { useContext } from 'react';

import CanvasCard from 'components/Visualisations/CanvasCard';
import { ChartTopBar } from 'components/Chart';
import DashboardGadgetBottomBar from 'components/DashboardGadgetBottomBar';
import FlexCentered from 'components/Common/FlexCentered';
import GqlClientProvider from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/GqlClientProvider';
import DashboardGadgetContext from 'contexts/DashboardGadgetContext';

import EntityInformationTableContent from './EntityInformationTableContent';

const EntityInformationTable = ({
  gadget,
}: {
  gadget: VisualisationDefinitions.EntityInformationTable;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <FlexCentered style={{ height: '100%', width: '100%' }}>
      <CanvasCard
        topBar={<ChartTopBar chartDefinition={gadget} />}
        content={
          <GqlClientProvider
            visName={gadget.name}
            visId={gadget.id}
            visType={gadget.type}
          >
            <EntityInformationTableContent gadget={gadget} />
          </GqlClientProvider>
        }
        bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
        isBottomBarAbsolute
      />
    </FlexCentered>
  );
};

export default EntityInformationTable;
